import React, { useEffect, useState } from 'react'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { DeleteComponent } from '../../../components/general/general-component/abstruct-component/DeleteComponent'
import SectionTopOfTable from '../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Table2 from '../../../components/table/Table2'
import InnerLoader from '../../../components/general/inner-loader/InnerLoader'
import Warning from '../../../components/general/general-component/warning-delete/Warning'
import { loadStatements } from '../../../store/Actions/ActionStatements'
import { ColumnStatements } from '../../../components/general/general-component/columns-component/ColumnStatements'
import { VariableStatements } from './VariableStatements'
import AddStatement from './AddStatement'
import FilterStatements from './FilterStatements'
import AddExpenses from '../expenses/AddExpenses'
import PopUpDetails from './PopUpDetails'
import EditStatement from './EditStatement'
import { UsePermissions, hasPermissions } from '../../../components/general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../../components/general/general-component/check-permissions'
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader'


const AllStatements = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const expenses_statements = hasPermissions([{ name: "expenses-statements" }], permissionss);
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { statements, loadingStatements } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit, setOpenDetails } = VariableStatements()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [statementsArr, setStatementsArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    const [openExpenses, setOpenExpenses] = useState(false)
    const [statement_id, setStatementId] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...statementsArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setStatementsArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, statementsArr]);
    useEffect(() => {
        if (statements?.length >= 0) {
            setStatementsArr(statements)
        }
    }, [statements]);
    useEffect(() => {
        dispatch(loadStatements())
    }, []);
    const handleDelete = (id) => {
        //dispatch(deleteUser(id, setloadDel,setIsDeleted,setIdDeleted));
    }
    const openAddStatement = e => {
        e.preventDefault()
        setOpen(true)
    }
    const goToExpenses = (e, id) => {
        e.preventDefault()
        navigate(`/statements-expenses/${id}`)
    }
    const openAddExpenses = (e, id) => {
        e.preventDefault()
        setStatementId(id)
        setOpenExpenses(true)
    }
    const detailsOfStatement = (id) => {
        console.log(id)
        setStatementId(id)
        setOpenDetails(true)
    }
    const { columns } = ColumnStatements(translate, warning, langLocal, handleEdit, goToExpenses, openAddExpenses, detailsOfStatement)
    return (
        <CheckLazyLoader>
            <CheckPermissions array={expenses_statements} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className="margin_main shadow_main">
                        <FilterStatements translate={translate} />
                    </div>
                    <div></div>
                    <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('statements')} titleBtn={translate('add_statement')} FunctionBtn={openAddStatement} />
                        {
                            loadingStatements ? <InnerLoader /> :
                                <Table2 col={columns} roo={statementsArr} />
                        }
                    </div>
                </main>
            </CheckPermissions>
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.open && (
                    <AddStatement open={state.open} setOpen={setOpen} />
                )
            }
            {
                openExpenses && (
                    <AddExpenses statement_id={statement_id} isStatment={false} open={openExpenses} setOpen={setOpenExpenses} />
                )
            }
            {
                state.openDetails && (
                    <PopUpDetails statement_id={statement_id} open={state.openDetails} setOpen={setOpenDetails} />
                )
            }
            {
                state.openEdit && (
                    <EditStatement arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </CheckLazyLoader>
    )
}

export default AllStatements

